import { render, staticRenderFns } from "./SignUpCarouselSixth.vue?vue&type=template&id=5a51f338&"
import script from "./SignUpCarouselSixth.vue?vue&type=script&lang=js&"
export * from "./SignUpCarouselSixth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports